import { Component, OnInit, Injector, LOCALE_ID, Inject } from '@angular/core';
import { Router, ActivatedRoute, ParamMap, Params } from '@angular/router';
import { DataService } from '../data.service';
import { BLOferta } from '../lib/bl/bloferta';
import { Oferta } from '../lib/model/oferta';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { HttpClient } from '@angular/common/http';
import { Alumne } from '../lib/model/alumne';
import { BLTrasllat } from '../lib/bl/bltrasllat';
import { Login } from '../lib/model/login';
import { FormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'login',
    styleUrls: ['login.component.css'],
    templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {

    initialized = false;
    escollirOferta = true;
    paywsback: Observable<string>;
    ofertaID: Observable<string>;
    pla: Observable<string>;
    ofertes: Oferta[];
    login: Login = new Login();
    startDate: Date;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        public dataService: DataService,
        private http: HttpClient,
        public snackBar: MatSnackBar,
        // Això he provat de posar-ho al DataService però no funciona, suposo que perquè no és un component, així que ho he posat aquí
        @Inject(LOCALE_ID) private locale,
      ) {
            this.startDate = new Date();
            this.startDate.setFullYear(this.startDate.getFullYear() - 20); // Data d'inici fa 20 anys
            console.log('Login locale:' + locale);
            this.dataService.init(locale);
      }

    public async inicia() {
        const bl = new BLTrasllat(this.dataService, this.http);
        try {
            this.dataService.trasllat = await bl.get(this.login, this.dataService.current_language);
            this.router.navigate(['/trasllat']);
        } catch (ex) {
            console.log(ex.Message);
            this.snackBar.open(ex.Message, null, {
                duration: 10000,
              });
        }
    }

    public async torna(paywsback: string) {
        const bl = new BLTrasllat(this.dataService, this.http);
        try {
            this.dataService.trasllat = await bl.getFromPayWSToken(paywsback);
            this.router.navigate(['/trasllat']);
        } catch (ex) {
            console.log(ex.Message);
            this.snackBar.open(ex.Message, null, {
                duration: 10000,
              });
        }
    }

    ngOnInit() {
        this.paywsback = this.route.queryParamMap.map(params => params.get('param') || 'None');
        this.paywsback.subscribe(x => {
            if (x !== 'None') {
                this.torna(x);
            }
        });

        this.ofertaID = this.route.queryParamMap.map(params => params.get('oferta') || 'None');
        this.ofertaID.subscribe(x => {
            if (x === 'None') {
                this.escollirOferta = true;
                this.loadOfertes();
            } else {
                this.escollirOferta = false;
                this.loadOferta(+x);
            }
        });

        this.pla = this.route.queryParamMap.map(params => params.get('pla') || 'None');
        this.pla.subscribe(x => {
            if (x !== 'None') {
                this.escollirOferta = false;
                this.loadOfertaByPla(x);
            }
        });

    }

    async loadOferta(id: number) {
        const bl = new BLOferta(this.dataService, this.http);
        this.login.oferta = await bl.getmaster(id, this.dataService.current_language);
        this.initialized = true;
    }

    async loadOfertaByPla(code: string) {
        const bl = new BLOferta(this.dataService, this.http);
        this.login.oferta = await bl.getmasterbypla(code, this.dataService.current_language);
        this.initialized = true;
    }

    async loadOfertes() {
        const bl = new BLOferta(this.dataService, this.http);
        this.ofertes = await bl.listmasters(this.dataService.current_language);
        this.initialized = true;
    }

    public localize(language: string) {
        let result = language;
        if (this.escollirOferta === false) {
            result = result + '/?oferta=' + this.login.oferta.value;
        }
        return result;
    }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts